import { USER_EARNING_STATUS } from '../earning-admin-list/constant';
import { DATA_INTER, RAW_INTER } from './constant';

export const convert = (raw: RAW_INTER): DATA_INTER => {
  const pendingBalance = raw?.earning
    ? raw.earning
        .filter((earning) => earning.status === USER_EARNING_STATUS.PENDING)
        .reduce((sum, earning) => sum + Number(earning.amount), 0)
    : 0;

  return {
    balance: raw.balance,
    pendingBalance: pendingBalance,
  };
};
